// extracted by mini-css-extract-plugin
export default {"wrapper":"Discover_wrapper__XwVCO","banner":"Discover_banner__Hq5Mh"};